import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { CButton, CFormLabel, CFormInput } from '@coreui/react'
import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser'
import { onedriveConfig } from '../../constants/onedriveConfig'
import { Plus } from 'lucide-react'

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: onedriveConfig.clientId,
    redirectUri: onedriveConfig.redirectUri,
    authority: onedriveConfig.authority,
  },
})

const OneDriveUploader = ({ onUploadSuccess }) => {
  const [uploading, setUploading] = useState(false)
  const [isInitialized, setIsInitialized] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize()
        setIsInitialized(true)
      } catch (error) {
        console.error('MSAL Initialization Error:', error)
      }
    }
    initializeMsal()
  }, [])

  const handleFileUpload = async (event) => {
    if (!isInitialized) {
      console.error('MSAL instance is not initialized')
      return
    }

    const file = event.target.files[0]
    if (!file) return

    setSelectedFile(file)
    setUploading(true)

    try {
      const accounts = msalInstance.getAllAccounts()
      if (accounts.length === 0) {
        await msalInstance.loginRedirect({
          scopes: onedriveConfig.scopes,
          // authority: onedriveConfig.authority,
        })
        return
      }

      const silentRequest = {
        scopes: onedriveConfig.scopes,
        account: accounts[0],
      }

      let accessToken
      try {
        const tokenResponse = await msalInstance.acquireTokenSilent(silentRequest)
        accessToken = tokenResponse.accessToken
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          console.warn('Silent token acquisition failed, redirecting...')
          await msalInstance.acquireTokenRedirect(silentRequest)
          return
        }
        throw error
      }

      const uploadUrl = `https://graph.microsoft.com/v1.0/me/drive/root:/${file.name}:/content`
      const response = await axios.put(uploadUrl, file, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': file.type,
        },
      })
      onUploadSuccess(response.data.webUrl)

      setSelectedFile(null) // Reset file selection
      event.target.value = '' // Reset file input field
    } catch (error) {
      console.error('Upload failed:', error.response?.data || error.message)
    } finally {
      setUploading(false)
    }
  }

  return (
    <div className="d-flex flex-column align-items-center">
      <CFormLabel
        className="d-flex flex-column align-items-center justify-content-center shadow"
        style={{
          width: '100px',
          height: '100px',
          borderRadius: '20px',
          background: 'var(--ui-color-primary, #2b7cd3)',
          cursor: 'pointer',
        }}
      >
        <Plus className="text-white" strokeWidth={2} size={40} />
        <CFormInput multiple className="d-none" type="file" onChange={handleFileUpload} accept="image/*, video/*, .pdf, .doc, .docx" />
      </CFormLabel>

      {selectedFile && <p className="mt-2 text-secondary">{selectedFile.name}</p>}
      {uploading && <p className="mt-2 text-info">Uploading...</p>}
    </div>
  )
}

export default OneDriveUploader
